import { Button } from 'react-bootstrap';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

interface OrdersTablePagingProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function OrdersTablePaging({ currentPage, totalPages, onPageChange }: OrdersTablePagingProps) {
  return (
    <div className="text-center mt-3">
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        <ChevronsLeft className="h-4 w-4" />
      </Button>
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="text-sm m-4">
        Page {currentPage} of {totalPages}
      </span>
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <ChevronsRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
